<template>
  <div class="main">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">模板编号</p>
        <el-input v-model="temId" placeholder="" clearable class="inputDiv" :disabled="true"></el-input>
      </div>
      <div class="stateDiv">
        <p class="searchText">模板名称</p>
        <el-input v-model="temName" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <!-- <div class="stateDiv">
        <p class="searchText">所属楼宇</p>
        <el-select v-model="buildingId" placeholder="请输入" clearable class="inputDiv">
          <el-option v-for="item in buildingValueList" :key="item.buildingId" :label="item.buildingName"
            :value="item.buildingId"></el-option>
        </el-select>
      </div> -->
      <div class="stateDiv">
        <p class="searchText">备注</p>
        <el-input type="textarea" v-model="remark" clearable class="inputDiv"></el-input>
      </div>
    </div>
    <div class="btnDiv">
      <el-button class="searchBtn" type="primary" @click="saveData">保存</el-button>
      <el-button class="searchBtn" type="primary" @click="goBack">取消</el-button>
    </div>
    <div class="copyList">
      <el-tree :data="data" :props="defaultProps" default-expand-all>
        <span slot-scope="{ node, data }" class="spanTreeLine">
          <span class="spanTree">{{ node.label }}</span>
          <img src="../../assets/images/copy.png" v-if="!hasShowingChild(data)"
            v-clipboard:copy="node.label + '：{'+node.label+'}'" v-clipboard:success="success" v-clipboard:error="error"
            class="imgs"/>
        </span>
      </el-tree>
    </div>
    <div class="quillEdit">
      <quill-editor ref="myTextEditor" v-model="content" :options="editorOption" class="ql-editor"></quill-editor>
    </div>
  </div>
</template>

<script>
import { addQuillTitle } from '../../assets/scripts/quill-title.js'
import contractDataList from '@/mock/contractDataList'
import { listBuildingInfos } from '@/api/searchList'
import { addTemp, editTemp, updateTemp } from '@/api/contract'

import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
// import Quill from 'quill' // 引入编辑器
import Quill from 'quill' // 引入编辑器
let fonts = ['SimSun', 'SimHei']
let Font = Quill.import('formats/font')
Font.whitelist = fonts // 将字体样式加入到白名单
const Parchment = Quill.import("parchment");
  class LineHeightAttributor extends Parchment.Attributor.Class {}
  const lineHeightStyle = new LineHeightAttributor(
    "lineheight",
    "ql-lineheight",
    {
      scope: Parchment.Scope.INLINE,
      whitelist: ["", "1", "1-5", "1-75", "2", "3", "4", "5"],
    }
  );
 Quill.register({ "formats/lineHeight": lineHeightStyle }, true);
 Quill.register('modules/imageDrop', ImageDrop);
 Quill.register('modules/imageResize', ImageResize);
// let fontSize = ['12px', '14px', '16px', '20px', '24px', '36px']
// let fontSizeStyle = Quill.import('attributors/style/size') // 修改字体大小
// fontSizeStyle.whitelist = fontSize

export default {
  name: 'addTemplate',
  data () {
    return {
      temId: '',
      temName: '',
      buildingId: '',
      remark: '',
      buildingValueList: [],
      isEdit: this.$route.query.isEdit,
      id: this.$route.query.id,
      toCode: false,
      // 富文本内容
      content: '',
      editorOption: {
        placeholder: '请在这里输入',
        modules: {
          imageDrop: true, // 图片拖拽
          imageResize: { // 放大缩小
            displaySize: true
          },
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
            // ['blockquote', 'code-block'], // 引用，代码块
            [{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 列表
            [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
            [{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
            [{ 'direction': 'rtl' }], // 文本方向
            [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
            // [{ 'size': fontSize }], // 字体大小
            [{ lineheight: ["", "1", "1-5", "1-75", "2", "3", "4", "5"] }], // 行高
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 几级标题
            [{ 'color': [] }, { 'background': [] }], // 字体颜色，字体背景颜色
            [{ 'font': fonts }], // 字体
            [{ 'align': [] }], // 对齐方式
            ['clean'], // 清除字体样式
            ['image', 'video'] // 上传图片、上传视频
          ]
        }
      },
      // 树形控件
      data: contractDataList,
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },

  beforeRouteLeave (to, form, next) {
    if (!this.toCode) {
      this.$confirm('要离开当前页面, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        next()
      })
    } else {
      next()
    }
  },

  mounted () {
    addQuillTitle()
    this.isEdit = this.$route.query.isEdit === true || this.$route.query.isEdit === 'true'
    // this.getBuildingList()
    if (this.isEdit) {
      this.editData()
    }
  },
  methods: {
    success (e) {
    },
    error (e) {
    },
    hasShowingChild (item) {
      // 如果节点有children,即为一级目录。mark为1说明是“租金价目表”
      if (item.children || item.mark === '1') {
        return true
      }
    },
    goBack () {
      this.toCode = true // 跳转置为true
      this.$router.push('/contract/template')
    },
    async getBuildingList () {
      let res = await listBuildingInfos({})
      if (res.code === 0) {
        this.buildingValueList = res.result
      }
    },
    // 编辑
    async editData () {
      let res = await editTemp({
        id: this.id
      })
      if (res.code === 0) {
        if (res.result.buildingName === null) {
          this.buildingId = null
        } else {
          this.buildingId = res.result.buildingId
        }
        this.temId = res.result.templateNumber
        this.temName = res.result.templateName
        // this.buildingId = res.result.buildingId
        this.remark = res.result.remark
        this.content = res.result.textContent
      }
    },
    // 保存
    async saveData () {
      this.contentRe = this.content.replace(/<br>/g, '<br />')
      if (this.isEdit) {
        // 编辑 更新
        let res = await updateTemp({
          buildingId: this.buildingId,
          id: this.id,
          remark: this.remark,
          templateName: this.temName,
          templateNumber: this.temId,
          textContent: this.contentRe
        })
        if (res.code === 0) {
          this.toCode = true // 跳转置为true
          this.$message({
            type: 'success',
            message: '编辑成功'
          })
          await this.$router.push('/contract/template')
        } else {
          this.$message({
            type: 'success',
            message: res.message
          })
        }
      } else {
        // 新增
        let res = await addTemp({
          buildingId: this.buildingId,
          // id: 0,
          remark: this.remark,
          templateName: this.temName,
          textContent: this.contentRe
        })
        if (res.code === 0) {
          this.toCode = true // 跳转置为true
          this.$message({
            type: 'success',
            message: '保存成功'
          })
          await this.$router.push('/contract/template')
        } else {
          this.$message({
            type: 'success',
            message: res.message
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.main {
  padding: 0.2rem;
}
.searchTitleDiv {
  width: 15rem;
  height: 0.66rem;
  margin-left: 0.2rem;
  margin-top: 0.05rem;
  display: flex;
  justify-content: space-around;
  .stateDiv {
    margin-top: 0.14rem;
  }
  .searchText {
    margin-top: 0.05rem;
    margin-right: 0.13rem;
    font-size: 0.2rem;
    color: #111111;
    float: left;
  }
  .inputDiv {
    width: 2.2rem;
    float: left;
  }
}
.btnDiv {
  margin-left: .3rem;
  .searchBtn {
    /*width: 1.20rem;*/
    /*height: 0.36rem;*/
    /*border-radius: 0.06rem;*/
    /*font-size: 0.18rem;*/
    margin-top: 0.14rem;
    margin-left: .2rem;
    /*padding-top: 0.1rem;*/
  }
}
.copyList {
  height: 5.95rem;
  width: 4rem;
  border: .01rem solid #bdc3c7;
  margin-left: 0;
  padding-top: .2rem;
  margin-top: .2rem;
  float: left;
  overflow-y: auto;
  .spanTreeLine {
    width: 100%;
  }
  .spanTree {
    padding-left: .04rem;
    float: left;
  }
  .imgs {
    width: .22rem;
    height: .23rem;
    cursor: pointer;
    margin-right: .3rem;
    float: right;
  }
}
.quillEdit {
  height: 6.5rem;
  width: 12rem;
  margin-right: 0;
  margin-top: .1rem;
  float: right;
}
.el-tree {
  background-color: #F7F8FA;
  color: #111111;
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-label::before,
.ql-snow .ql-picker.ql-lineheight .ql-picker-item::before {
  content: "行高";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="1"]::before {
  content: "1";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value="1-5"]::before,
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="1-5"]::before {
  content: "1.5";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value="1-75"]::before,
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="1-75"]::before {
  content: "1.75";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="2"]::before {
  content: "2";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="3"]::before {
  content: "3";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="4"]::before {
  content: "4";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="5"]::before {
  content: "5";
}
.ql-snow .ql-picker.ql-lineheight {
  width: 70px;
}
.ql-snow .ql-editor .ql-lineheight-1 {
  line-height: 1;
}
.ql-snow .ql-editor .ql-lineheight-1-5 {
  line-height: 1.5;
}
.ql-snow .ql-editor .ql-lineheight-1-75 {
  line-height: 1.75;
}
.ql-snow .ql-editor .ql-lineheight-2 {
  line-height: 2;
}
.ql-snow .ql-editor .ql-lineheight-3 {
  line-height: 3;
}
.ql-snow .ql-editor .ql-lineheight-4 {
  line-height: 4;
}
.ql-snow .ql-editor .ql-lineheight-5 {
  line-height: 5;
}

</style>
